import { render, staticRenderFns } from "./PoiBlock.vue?vue&type=template&id=5add1484&"
import script from "./PoiBlock.vue?vue&type=script&lang=js&"
export * from "./PoiBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PoiBlock.vue"
export default component.exports